import React from "react";
import {
  AppBar,
  Toolbar,
  IconButton,
  Slide,
  Typography,
  useMediaQuery,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { useDrawer } from "../context/drawerProvider";

const DrawerButton = () => {
  const [drawerOpen, setDrawerOpen] = useDrawer();

  return (
    <Slide
      appear={false}
      direction="left"
      in={!drawerOpen}
      mountOnEnter
      unmountOnExit
    >
      <IconButton
        size="large"
        aria-expanded={drawerOpen}
        onClick={() => setDrawerOpen(true)}
        disableTouchRipple
      >
        <MenuIcon />
      </IconButton>
    </Slide>
  );
};

const NavBar = () => {
  const isLandscape = useMediaQuery(
    "(pointer: coarse) and (orientation: landscape)"
  );

  return (
    <AppBar
      sx={{
        backgroundColor: "transparent",
        backgroundImage: "none",
        position: "static",
        background:
          "linear-gradient(180deg, rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.3))",
        boxShadow: "1px 1px 10px rgba(0, 0, 0, 0.4)",
      }}
    >
      <Toolbar
        sx={{
          justifyContent: "space-between",
          mr: 1,
          ml: 2,
        }}
        disableGutters
        variant={isLandscape ? "dense" : "regular"}
      >
        <Typography sx={{ fontSize: "1.3rem" }}>
          R.I.P ConfusedHeathen
        </Typography>
        <DrawerButton />
      </Toolbar>
    </AppBar>
  );
};

export default NavBar;
